<template>
  <v-container class="px-6 px-sm-12">
    <PageHeader :header-text="'Data Admin'" :header-icon="'mdi-database'" />
    <v-card>
      <v-toolbar class="primary--text">
        <v-toolbar-title class="headline primary--text">
          <v-icon color="primary" left>mdi-database</v-icon>
          Data Admin</v-toolbar-title
        >
      </v-toolbar>
      <v-tabs v-model="tab" vertical>
        <v-tab href="#locations" class="d-flex justify-start">
          <v-icon left>mdi-map-marker</v-icon>
          Locations
        </v-tab>
        <v-tab href="#activities" class="d-flex justify-start">
          <v-icon left>mdi-progress-clock</v-icon>
          Activities
        </v-tab>
        <v-tab href="#vessels" class="d-flex justify-start">
          <v-icon left>mdi-ferry</v-icon>
          Vessels
        </v-tab>
        <v-tab href="#tanks" class="d-flex justify-start">
          <v-icon left>mdi-car-coolant-level</v-icon>
          Tanks
        </v-tab>
        <v-tab href="#bulks" class="d-flex justify-start">
          <v-icon left>mdi-water</v-icon>
          Bulks
        </v-tab>
        <v-tab href="#clients" class="d-flex justify-start">
          <v-icon left>mdi-account-group</v-icon>
          Clients
        </v-tab>
        <v-tabs-items :value="tab">
          <v-tab-item value="locations">
            <data-admin-entity
              ref="locationsAdmin"
              title="Locations"
              icon="mdi-map-marker"
              :tableHeaders="locationHeaders"
              :tableData="locationsTableData"
              formComponent="LocationsForm"
              v-on:submit="submitLocation"
              v-on:delete="deleteLocation"
            />
          </v-tab-item>
          <v-tab-item value="activities">
            <data-admin-entity
              ref="activitiesAdmin"
              title="Activities"
              icon="mdi-progress-clock"
              :tableHeaders="activitiesHeaders"
              :tableData="activitiesTableData"
              formComponent="ActivitiesForm"
              v-on:submit="submitActivity"
              v-on:delete="deleteActivity"
            />
          </v-tab-item>
          <v-tab-item value="vessels">
            <data-admin-entity
              ref="vesselsAdmin"
              title="Vessels"
              icon="mdi-ferry"
              :tableHeaders="vesselsHeaders"
              :tableData="vesselsTableData"
              formComponent="VesselForm"
              v-on:submit="submitVessel"
              v-on:delete="deleteVessel"
            />
          </v-tab-item>
          <v-tab-item value="tanks">
            <data-admin-entity
              ref="tankAdmin"
              title="Tanks"
              icon="mdi-car-coolant-level"
              :tableHeaders="tankHeaders"
              :tableData="tanksTableData"
              formComponent="TankForm"
              v-on:submit="submitTank"
              v-on:delete="deleteTank"
              group-by="vesselName"
              :groupIcon="'mdi-ferry'"
            />
          </v-tab-item>
          <v-tab-item value="bulks">
            <data-admin-entity
              ref="bulksAdmin"
              title="Bulks"
              icon="mdi-water"
              :tableHeaders="bulksHeaders"
              :tableData="bulksForTableData"
              formComponent="BulkForm"
              v-on:submit="submitBulk"
              v-on:delete="deleteBulk"
            />
          </v-tab-item>
          <v-tab-item value="clients">
            <data-admin-entity
              ref="clientsAdmin"
              title="Clients"
              icon="mdi-account-group"
              :tableHeaders="clientsHeaders"
              :tableData="clientsTableData"
              formComponent="ClientForm"
              v-on:submit="submitClient"
              v-on:delete="deleteClient"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import PageHeader from '../components/ui/PageHeader.vue';
import DataAdminEntity from '../components/admin/DataAdminEntity.vue';
import DataAdminEntitiesMixin from '../mixins/DataAdminEntitiesMixin'; // mixin for table data and methods for create/update/delete for each entity

export default {
  name: 'DataAdmin',
  components: {
    PageHeader,
    DataAdminEntity,
  },
  mixins: [DataAdminEntitiesMixin],
  computed: {
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } });
      },
      get() {
        return this.$route.query.tab;
      },
    },
  },
  watch: {
    activeSiteId(newVal) {
      this.loadRequiredDataForSite();
    },
  },
  created() {
    this.loadRequiredDataForSite();
  },
  methods: {
    loadRequiredDataForSite() {
      this.$store.dispatch('activitiesStore/loadAvailableActivities', this.activeSiteId);
      this.$store.dispatch('locationsStore/loadVesselLocations', this.activeSiteId);
      this.$store.dispatch('vesselsStore/loadVessels', this.activeSiteId);
      this.$store.dispatch('bulksStore/loadBulks', this.activeSiteId);
      this.$store.dispatch('bulksStore/loadBulkTypes');
      this.$store.dispatch('tanksStore/loadVesselTanks', this.activeSiteId);
      this.$store.dispatch('clientsStore/loadClients', this.activeSiteId);
    },
  },
};
</script>

<style>
</style>
